export enum GoalTypeEnum {
    Input = 0,
    Consent = 1
}